export const YES = { id: 'yes', label: 'Sì' };
export const NO = { id: 'no', label: 'No' };
